import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as r, normalizeClass as n, createElementVNode as i } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconCloudRainWind",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], u = /* @__PURE__ */ i("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.598 2.209a3 3 0 0 0-3.24 4.89.5.5 0 0 1-.715.7A4 4 0 1 1 8.209 3.5h.54c.001 0 0 0 0 0a2.75 2.75 0 0 1 1.529 5.037.5.5 0 1 1-.556-.832A1.75 1.75 0 0 0 8.75 4.5h-.895a.5.5 0 0 1-.48-.357A3 3 0 0 0 5.599 2.21Z",
  "clip-rule": "evenodd"
}, null, -1), _ = /* @__PURE__ */ i("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.297 7.04a.5.5 0 0 1 .263.657l-1.5 3.5a.5.5 0 1 1-.92-.394l1.5-3.5a.5.5 0 0 1 .657-.263Zm-1.6-1a.5.5 0 0 1 .263.657l-1.5 3.5a.5.5 0 1 1-.92-.394l1.5-3.5a.5.5 0 0 1 .657-.263Zm4 0a.5.5 0 0 1 .263.657l-1.5 3.5a.5.5 0 1 1-.92-.394l1.5-3.5a.5.5 0 0 1 .657-.263Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  u,
  _
];
function f(e, h, l, p, v, a) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--cloud-rain-wind"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Cloud Rain Wind",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const w = /* @__PURE__ */ o(s, [["render", f]]);
export {
  w as default
};
//# sourceMappingURL=cloud-rain-wind.js.map
